import { useContext, useState, useEffect } from 'react';
import { DiagnosticContext, showFundingRecommendations, hasRequiredLevels } from '../../helpers/functions';
import { categories } from '../../services/londi-constants';
import Questionnaire from '../Questionnaire';
import Tabs from '../Tabs';
import Accordion from '../Accordion';
import FundingRecomendationsFilter, { DEFAULT_RECOMMENDATIONS_FILTER } from './FundingRecomendationsFilter';
import CollapsibleList from '../CollapsibleList';
import PageHeading from '../../elements/page-heading';
import Container from '../../elements/container';
import FundingRecommendationsDetails from './FundingRecommendationsDetails';
import { Alert } from 'flowbite-react';

const FundingRecomendations = () => {
  const [readingRecomendations, setReadingRecomendations] = useState(true);
  const [writingRecomendations, setWritingRecomendations] = useState(true);
  const [countingRecomendations, setCountingRecomendations] = useState(true);
  const [feedback, setFeedback] = useState(false);
  const { state } = useContext(DiagnosticContext);
  const [filterQuery, setFilterQuery] = useState(DEFAULT_RECOMMENDATIONS_FILTER);

 const [missingKsError, setMissingKsError] = useState(false);
 useEffect(() => {
   setMissingKsError(!hasRequiredLevels(state));
 }, [state]);

  const proceedFeedback = () => {
    setReadingRecomendations(false);
    setWritingRecomendations(false);
    setCountingRecomendations(false);
    setFeedback(true);
  };

  return (
    <>
      <Tabs />
      <Container className="flex flex-col items-center">
        <PageHeading stretch title="Förderempfehlung" />
        {missingKsError && (
  <Alert type="error" className="my-4">
    Bitte erfassen Sie <strong>Kompetenzstufe&nbsp;1 und 3</strong> in
    mindestens einem Lernbereich (Lesen, Schreiben oder Rechnen), bevor Sie die
    Förderempfehlungen anzeigen.
  </Alert>
)}
        <div className="py-6 space-y-4 -mt-6 px-4 sm:px-0">
          <p className="text-base sm:text-lg leading-7 sm:leading-8 text-gray-600">
            Wir empfehlen Ihnen die folgenden Förderprogramme.
            <br />
            Die Reihenfolge der Förderverfahren richtet sich nach der wissenschaftlicher Güte des Verfahrens und der Passung von ermitteltem
            Förderprofil des Kindes und den Förderschwerpunkten des Verfahrens. Je weiter oben ein Verfahren angezeigt wird desto besser ist die
            wissenschaftliche Güte / Passung. Weitere Informationen hierzu finden Sie bei der detaillierten{' '}
            <a href="https://londi.de/ueber-londi/informationen-hilfssystem/" target="_blank" className="link" rel="noreferrer">
              Beschreibung der Funktionsweise
            </a>
            .
          </p>
          <p className="text-md font-medium">Stand der Daten: Ende 2020</p>
        </div>
        <FundingRecomendationsFilter filter={filterQuery} onChange={setFilterQuery} />
        <div className="overflow-x-hidden w-full text-base sm:text-lg md:text-xl space-y-2 mt-8 px-4 sm:px-0">
          {(() => {
            const fundingRecommendations = showFundingRecommendations(state, filterQuery);
            const readingRecommendations = fundingRecommendations
              .filter((el) => el.category === categories.Reading)
              .map((el) => el.results)
              .flat();
            const writingRecommendations = fundingRecommendations
              .filter((el) => el.category === categories.Writing)
              .map((el) => el.results)
              .flat();
            const countingRecommendations = fundingRecommendations
              .filter((el) => el.category === categories.Math)
              .map((el) => el.results)
              .flat();

            return (
              <>
                {(state.readingResults || state.readingK1Results) && readingRecommendations.length > 0 && (
                  <Accordion
                    open={readingRecomendations}
                    toggle={() => setReadingRecomendations(!readingRecomendations)}
                    label="Förderempfehlungen Lesen:"
                  >
                    <div className="space-y-2">
                      <CollapsibleList
                        tests={readingRecommendations}
                        renderItem={(res, index) => <FundingRecommendationsDetails index={index + 1} key={res.id} res={res} />}
                      />
                    </div>
                  </Accordion>
                )}
                {(state.writingResults || state.writingK1Results) && writingRecommendations.length > 0 && (
                  <Accordion
                    open={writingRecomendations}
                    toggle={() => setWritingRecomendations(!writingRecomendations)}
                    label="Förderempfehlungen Schreiben:"
                  >
                    <div className="space-y-2">
                      <CollapsibleList
                        tests={writingRecommendations}
                        renderItem={(res, index) => <FundingRecommendationsDetails index={index + 1} key={res.id} res={res} />}
                      />
                    </div>
                  </Accordion>
                )}
                {(state.countingResults || state.countingK1Results) && countingRecommendations.length > 0 && (
                  <Accordion
                    open={countingRecomendations}
                    toggle={() => setCountingRecomendations(!countingRecomendations)}
                    label="Förderempfehlungen Rechnen:"
                  >
                    <div className="space-y-2">
                      <CollapsibleList
                        tests={countingRecommendations}
                        renderItem={(res, index) => <FundingRecommendationsDetails index={index + 1} key={res.id} res={res} />}
                      />
                    </div>
                  </Accordion>
                )}
              </>
            );
          })()}
        </div>
        <button
          onClick={() => proceedFeedback()}
          className="text-white font-semibold bg-mainBlue w-full sm:w-56 md:w-72 mb-8 h-12 sm:h-10 md:h-14 text-base sm:text-lg md:text-2xl my-10 px-4"
        >
          Weiter zur Druckübersicht
        </button>
        {feedback && <Questionnaire />}
        <p className="text-lg md:text-xl mb-10 mt-3" style={{ marginBottom: feedback ? '300px' : '' }}>
          Auf der nächsten Seite können alle Ergebnisse als PDF ausgedruckt werden.
        </p>
      </Container>
    </>
  );
};

export default FundingRecomendations;
